<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{
                $t("integraciones")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("productosNoRelacionados") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="cambioBusiness(), (idTpv = -1), (idsTPV = [])"
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  />
                </el-select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="listTPV"
                  ><strong>{{ $t("TPV") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idTpv"
                  filterable
                  @change="
                    tabs == 'Productos' ? getProducts(0) : getSubproducts(0)
                  "
                  :placeholder="$t('seleccionaTpv')"
                >
                  <el-option
                    v-for="tpv in listTpv"
                    class="select-primary"
                    :value="tpv.id"
                    :label="tpv.nameShow"
                    :key="tpv.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="configTpv">
        <vue-tabs
          class="col-md-12"
          @tab-change="handleTabChange"
          v-model="tabs"
        >
          <v-tab title="" :disabled="true"></v-tab>

          <!-- Productos Tab -->
          <v-tab title="Productos">
            <div class="row">
              <div class="col-md-12 mt-2">
                <!-- Barra de búsqueda y botones SIEMPRE visibles -->
                <div
                  class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
                  style="gap: 0.5rem"
                >
                  <div class="flex-grow-1">
                    <div class="input-group w-100">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('buscar')"
                        v-model="searchQuery2"
                        @keyup.enter.prevent="searchProducts"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-secondary"
                          type="button"
                          @click="searchProducts"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          class="btn btn-secondary"
                          type="button"
                          @click="removeSearchProduct"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap" style="gap: 0.5rem">
                    <button
                      v-if="listProducts.length > 0"
                      class="btn btn-primary"
                      @click="showReplaceConfirmation(0)"
                    >
                      <i class="fas fa-save"></i>&nbsp;{{ $t("generarPlu") }}
                    </button>
                    <button
                      v-if="listTpv.length > 0"
                      class="btn btn-secondary"
                      type="button"
                      @click="confirmarReplicacionProductos"
                      style="white-space: nowrap;"
                    >
                      {{ $t("replicarPLUPRod") }}
                    </button>
                    <button
                      v-if="listTpv.length > 0"
                      class="btn btn-secondary"
                      @click="$modal.show('modalSeleccionBusiness')"
                    >
                      {{ $t("replicarPLUsaBusinesses") }}
                    </button>
                  </div>
                </div>
                <!-- Tabla de productos o mensaje -->
                <div class="table-responsive" v-if="listProducts.length > 0">
                  <table class="table table-bordered table-striped text-nowrap">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombre") }}</th>
                        <th>{{ $t("precio") }}</th>
                        <th>PLU</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="obj in listProducts" :key="obj.id">
                        <td v-if="obj.nameprice.trim() !== ''">
                          {{
                            obj.name.trim() + " [" + obj.nameprice.trim() + "]"
                          }}
                        </td>
                        <td v-else>
                          {{ obj.name.trim() }}
                        </td>
                        <td>{{ obj.price | currency }}</td>
                        <td width="20%">
                          <input
                            class="form-control"
                            type="text"
                            v-model="obj.newPLU"
                          />
                        </td>
                        <td align="center">
                          <button
                            v-if="obj.PLU == obj.newPLU"
                            class="btn btn-primary"
                          >
                            <i class="fa-solid fa-floppy-disk"></i>
                          </button>
                          <button
                            v-else
                            class="btn btn-warning"
                            @click="changedPLU(obj, 0)"
                          >
                            <i class="fa-solid fa-floppy-disk"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="alert alert-danger m-3 w-100" role="alert">
                  No se encontraron productos sin PLU. Todos los productos están
                  configurados correctamente.
                </div>
              </div>
            </div>
          </v-tab>

          <!-- Materias Primas Tab -->
          <v-tab title="Materias Primas">
            <div class="row">
              <div class="col-md-12 mt-2">
                <!-- Barra de búsqueda y botones SIEMPRE visibles -->
                <div
                  class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
                  style="gap: 0.5rem"
                >
                  <div class="flex-grow-1">
                    <div class="input-group w-100">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('buscar')"
                        v-model="searchQuery"
                        @keyup.enter.prevent="searchSubproducts"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-secondary"
                          type="button"
                          @click="searchSubproducts"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          class="btn btn-secondary"
                          type="button"
                          @click="removeSearchSubProduct"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap" style="gap: 0.5rem">
                    <button
                      class="btn btn-primary"
                      @click="showReplaceConfirmation(1)"
                    >
                      <i class="fas fa-save"></i>&nbsp;{{ $t("generarPlu") }}
                    </button>
                   <button
                      v-if="listTpv.length > 0"
                      class="btn btn-secondary"
                      type="button"
                      @click="confirmarReplicacionSubproductos()"
                      style="white-space: nowrap;"
                    >
                      {{ $t("replicarPLUSubPRod") }}
                    </button> 
                     <button
                        v-if="listTpv.length > 0"
                        class="btn btn-secondary"
                        type="button"
                        @click="$modal.show('modalSeleccionBusinessSubproducts')"
                        style="white-space: nowrap;"
                      >
                      {{ $t("replicarPLUaBusinesses") }}
                      </button>
                  </div>
                </div>
                <!-- Tabla de materias primas o mensaje -->
                <div class="table-responsive" v-if="listSubproducts.length > 0">
                  <table class="table table-bordered table-striped text-nowrap">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombre") }}</th>
                        <th>{{ $t("precio") }}</th>
                        <th>PLU</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="obj in listSubproducts" :key="obj.id">
                        <td>{{ obj.name.trim() }}</td>
                        <td>{{ obj.price | currency }}</td>
                        <td width="20%">
                          <input
                            class="form-control"
                            type="text"
                            v-model="obj.newPLU"
                          />
                        </td>
                        <td align="center">
                          <button
                            v-if="obj.PLU == obj.newPLU"
                            class="btn btn-primary"
                          >
                            <i class="fa-solid fa-floppy-disk"></i>
                          </button>
                          <button
                            v-else
                            class="btn btn-warning"
                            @click="changedPLU(obj, 1)"
                          >
                            <i class="fa-solid fa-floppy-disk"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="alert alert-danger m-3 w-100" role="alert">
                  No se encontraron materias primas sin PLU. Todas las materias primas están configuradas correctamente.
                </div>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </template>

      <template v-else>
        <div class="col-md-12">
          <div class="alert alert-primary text-center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>
            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.
            </span>
          </div>
        </div>
      </template>
    </div>

    <modal name="modalSeleccionBusiness" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
    <div>
      <div class="modal-header">
        <h4 style="margin: 0px">{{ $t("replicarPLUaBusinesses") }}</h4>
      </div>

      <div class="modal-body">
        <!-- Checkbox seleccionar todos -->
        <el-checkbox
          v-model="selectAllProducts"
          @change="toggleSelectAllProducts"
          style="margin-bottom: 12px;"
        >
          {{ $t("seleccionarTodos") }}
        </el-checkbox>

        <!-- Lista de negocios -->
        <div v-for="business in listBusinessesCompany" :key="business.id">
          <el-checkbox
            v-model="selectedBusinessCompany"
            :label="business.id"
            border
            class="checkbox-element"
            style="width: 100%; margin-bottom: 6px;"
            @change="checkIfAllSelectedProducts"
          >
            {{ business.establishmentName }}
          </el-checkbox>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default" @click="closeModal()">
          <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
        </button>

        <button
          class="btn btn-primary"
          :disabled="selectedBusinessCompany.length === 0"
          @click="confirmarReplicacionProductosPLUBusiness"
        >
          <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
        </button>
      </div>
    </div>
  </modal>

  <modal
    name="modalSeleccionBusinessSubproducts"
    :adaptive="true"
    :scrollable="true"
    height="auto"
    :clickToClose="false"
  >
    <div>
      <div class="modal-header">
        <h4 style="margin: 0px">{{ $t("replicarPLUaBusinesses") }}</h4>
      </div>

      <div class="modal-body">
        <!-- Checkbox seleccionar todos -->
        <el-checkbox
          v-model="selectAll"
          @change="toggleSelectAllSubproducts"
          style="margin-bottom: 12px;"
        >
          {{ $t("seleccionarTodos") }}
        </el-checkbox>

        <!-- Lista de negocios -->
        <div v-for="business in listBusinessesCompany" :key="business.id">
          <el-checkbox
            v-model="selectedBusinessCompanySubproducts"
            :label="business.id"
            border
            class="checkbox-element"
            style="width: 100%; margin-bottom: 6px;"
            @change="checkIfAllSelected"
          >
            {{ business.establishmentName }}
          </el-checkbox>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default" @click="closeModalSubproducts()">
          <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
        </button>

        <button
          class="btn btn-primary"
          :disabled="selectedBusinessCompanySubproducts.length === 0"
          @click="confirmarReplicacionSubProductosPLUBusiness"
        >
          <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
        </button>
      </div>
    </div>
  </modal>

  </div>
</template>

<script>
import {
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
  Checkbox,

} from "element-ui";
import swal from "sweetalert2";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch(
      "setNameRoute",
      this.$i18n.t("productosNoRelacionados")
    );
    this.tabs = "Productos";
    this.getBusiness();

    this.loading.close();
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      loading: false,
      tabs: "",
      idBusiness: 0,
      listBusinesses: [],
      query: "",
      listProducts: [],
      listSubproducts: [],
      searchQuery: "",
      searchQuery2: "",
      respuesta: false,
      config98: false,
      config99: false,
      config101: false,
      loadingGeneral: null,
      configTpv: false,
      //tpv
      listTpv: [],
      idsTPV: [],
      idTpv: 0,
      list: [],
      selectedBusinessCompany: [], // seleccionados para productos
      selectAllProducts: false,
      listBusinessesCompany: [],
      idBusinessData: this.idBusiness !== null && this.idBusiness !== undefined ? this.idBusiness : -1,    // checkbox "seleccionar todos"
      selectAll: false,
      selectedBusinessCompanySubproducts: [], // seleccionados para materias primas
      cargaInicial: false,
      idBusinessData: null,
    };
  },
  watch: {
    idBusiness() {
      if (this.idBusiness !== 0 && !this.cargaInicial) {
        this.cargaInicial = true;
        this.idBusinessData = this.idBusiness;
        this.cambioBusiness();
      }
    },
    listElmExtra: {
      deep: true,
      handler(nuevaLista) {
        this.listExtraElement = nuevaLista;
        this.idRepartidorData = nuevaLista;
      }
    }
  },

  mounted() {
    if (this.idBusiness && this.idBusiness !== 0) {
      this.idBusinessData = this.idBusiness;
      this.cambioBusiness();
      this.cargaInicial = true;
    }
  },
  methods: {
    getBusiness() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getConfigTpv(98);
          vm.getConfigProductosNoRelacionados();
          vm.getTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTpv() {
      this.listTpv = [];
      this.idsTPV = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.idTpv = vm.idsTPV[0];

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            //RESETEO LAS VARIABLES
            vm.listProducts = [];

            if (vm.tabs == "Materias Primas") {
              vm.getSubproducts(vm.idsTPV[0]);
            } else if (vm.tabs == "Productos") {
              vm.getProducts(vm.idsTPV[0]);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProducts(idTpvTem) {
      const controller = this.searchQuery2
        ? "gstock/searchProductsByBusinessProductosNoRelacionados/" +
        this.searchQuery2
        : "gstock/getProductsProductosNoRelacionados";

      var idTpvSql = idTpvTem != 0 ? idTpvTem : this.idTpv;

      let config = {
        params: {
          //idBusiness: this.idBusiness,
          idTpv: idTpvSql,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProducts = response.data.result;
            vm.respuesta = true;
          } else {
            vm.loadingGeneral.close();
            swal({
              title: this.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getSubproducts(idTpvTem) {
      const controller = this.searchQuery
        ? "gstock/searchSubproductsByBusinessProductosNoRelacionados/" +
        this.searchQuery
        : "gstock/getSubproductsByBusinessProductosNoRelacionados";

      var idTpvSql = idTpvTem != 0 ? idTpvTem : this.idTpv;

      let config = {
        params: {
          idTpv: idTpvSql,
          //idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result;
            vm.respuesta = true;
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigTpv(numConfig) {
      let config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: numConfig,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (numConfig == 98) {
              vm.config98 = response.data.result;
            } else if (numConfig == 99) {
              vm.config99 = response.data.result;
            } else if (numConfig == 101) {
              vm.config101 = response.data.result;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async cambioBusiness() {
      const businessData = this.idBusiness;
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      try {
        this.getConfigProductosNoRelacionados();
        this.getTpv();
        this.getBusinessesByCompanyId(businessData);
      } catch (e) {
        console.error("Error durante cambioBusiness:", e);
      } finally {
        this.loadingGeneral.close();
      }
    },

    getConfigProductosNoRelacionados() {
      let configIdentificador = 117;

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador,
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.configTpv = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      this.searchQuery = "";
      if (this.tabs == "Materias Primas") {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        this.getSubproducts(0);
        this.loadingGeneral.close();
      } else if (this.tabs == "Productos") {
        this.getProducts(0);
      }
    },
    searchSubproducts() {
      if (this.searchQuery !== undefined && this.searchQuery !== "") {
        this.$router.push({
          name: "search-prducto-pnr",
          params: { query: this.searchQuery },
        });
        //this.isSearch = true;
      }
    },
    removeSearchSubProduct() {
      if (this.searchQuery && this.searchQuery !== "") {
        this.searchQuery = "";
        //  this.isSearch = false;
        this.$router.push({ name: "productosnorelacionados" });
        this.getSubproducts(0);
      }
    },
    searchProducts() {
      // console.log("route", this.searchQuery2)
      if (this.searchQuery2 !== undefined && this.searchQuery2 !== "") {
        this.$router.push({
          name: "search-prducto-pnr",
          params: { query: this.searchQuery2 },
        });
        //  this.isSearch = true;
      }
    },
    removeSearchProduct() {
      if (this.searchQuery2 && this.searchQuery2 !== "") {
        this.searchQuery2 = "";
        //this.isSearch = false;
        this.$router.push({ name: "productosnorelacionados" });
        this.getProducts(0);
      }
    },
    changedPLU(obj, tipo) {
      let config = {};
      if (tipo == 0) {
        config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            rate: obj.rate,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      } else {
        config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      }

      let params = {
        idBusiness: this.idBusiness,
        idProduct: obj.id,
        newPLU: obj.newPLU,
        tipo: tipo,
        jwt: this.$store.getters.jwt,
      };
      console.log(params);
      let vm = this;
      let controller = "gstock/updatePLU";
      this.axios
        .post(
          this.$store.getters.apiUrl + "integracion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            let notify = vm.$t("actualizado");
            vm.$notify({
              message:
                vm.$t("coste") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            obj.PLU = obj.newPLU;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showReplaceConfirmation(tipo) {
      if (tipo == 0) {
        swal
          .fire({
            position: "center",
            title: this.$t("atencion"),
            type: "warning",
            text: this.$t("mensajeAviso"),
            showCloseButton: false,
            reverseButtons: true,
            allowOutsideClick: false,
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: this.$t("botonCancelar"),
            confirmButtonText: this.$t("botonAceptar"),
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          })
          .then((result) => {
            if (result.value) {
              this.generateAllPLUs(0);
            } else if (result.dismiss) {
            } else if (result.dismiss === swal.DismissReason.close) {
            }
          });
      } else if (tipo == 1) {
        swal({
          position: "center",
          title: this.$t("atencion"),
          text: this.$t("mensajeAvisoSubProducto"),
          type: "warning",
          showCloseButton: false,
          reverseButtons: true,
          allowOutsideClick: false,
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: this.$t("botonCancelar"),
          confirmButtonText: this.$t("botonAceptar"),
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            this.generateAllPLUs(1);
          } else if (result.dismiss) {
          } else if (result.dismiss === swal.DismissReason.close) {
          }
        });
      }
    },
    generateAllPLUs(tipo) {
      const controller = "gstock/generateAllPLUs";
      let config = {};
      if (tipo == 0) {
        config = {
          params: {
            idBusiness: this.idBusiness,
            tipo: tipo,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      } else {
        config = {
          params: {
            idBusiness: this.idBusiness,
            tipo: tipo,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      }

      let params = {
        idBusiness: this.idBusiness,
        tipo: tipo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "integracion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("PLUsGenerados"),
              type: "success",
              timeout: 3000,
            });
            vm.getProducts();
            vm.getSubproducts();
          } else {
            vm.$notify({
              message: response.data.message,
              type: "error",
              timeout: 3000,
            });
          }
        })
        .catch(function (error) {
          console.error(error);
          vm.$notify({
            message: vm.$t("errorGenerandoPLUs"),
            type: "error",
            timeout: 3000,
          });
        });
    },

    replicarProductosTpvs() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
            "integracion/gstock/replicarProductosTpvs",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            const data = response.data;
            const resumen = data.resumen || {};
            console.log(resumen);
            const actualizados = resumen.productosActualizados || 0;
            const errores = resumen.productosConErrores || 0;

            const mensajeResumen =
              `<div style="text-align: left;">` +
              `✅ <strong>${vm.$t("actualizados")}:</strong> ${actualizados}<br>` +
              `❌ <strong>${vm.$t("conErrores")}:</strong> ${errores}` +
              `</div>`;

            // Si no hay actualizados, mostrar advertencia
            if (actualizados === 0) {
              swal({
                title: vm.$t("atencion"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-warning btn-fill",
                icon: "warning",
              });
            } else {
              // Si hubo actualizados, mostrar éxito
              swal({
                title: vm.$t("pluReplicadosExitosamente"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-success btn-fill",
                icon: "success",
              });
            }
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.error("Error:", error);

            let msg = vm.$t("errorDesconocido");
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              msg = error.response.data.message;
            }

            swal({
              title: vm.$t("atencion"),
              text: msg,
              confirmButtonClass: "btn btn-info btn-fill",
              icon: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          icon: "error",
        });
      }
    },

    replicarMateriasPrimasTpvs() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
            "integracion/gstock/replicarMateriasPrimasTpvs",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            const data = response.data;
            const resumen = data.resumen || {};

            const actualizados = resumen.subproductosActualizados || 0;
            const errores = resumen.subproductosConErrores || 0;

            const mensajeResumen =
              `<div style="text-align: left;">` +
              `✅ <strong>${vm.$t("actualizados")}:</strong> ${actualizados}<br>` +
              `❌ <strong>${vm.$t("conErrores")}:</strong> ${errores}` +
              `</div>`;

            // Si no hay actualizados, mostrar como advertencia
            if (actualizados === 0) {
              swal({
                title: vm.$t("atencion"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-warning btn-fill",
                icon: "warning",
              });
            } else {
              // Si hubo actualizados, mostrar como éxito
              swal({
                title: vm.$t("pluReplicadosExitosamente"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-success btn-fill",
                icon: "success",
              });
            }
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.error("Error:", error);

            let msg = vm.$t("errorDesconocido");
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              msg = error.response.data.message;
            }

            swal({
              title: vm.$t("atencion"),
              text: msg,
              confirmButtonClass: "btn btn-info btn-fill",
              icon: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          icon: "error",
        });
      }
    },

    replicarPLUsProductosBusiness() {

      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          idsBusinesses: this.selectedBusinessCompany,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl +
            "integracion/gstock/replicarProductosPLUsBusiness",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            // Datos de respuesta
            let data = response.data;

            // Construir resumen de nombres duplicados si existen
            let duplicados = data.productosConNombresDuplicadosEnOrigen || [];

            let mensajeDuplicados = "";
            if (duplicados.length > 0) {
              mensajeDuplicados =
                "<ul style='padding-left: 20px;'>" +
                duplicados
                  .map(function (d) {
                    return `<li><strong>${d.name}</strong> ${vm.$t('seRepite')} ${d.ids.length} veces.</li>`;
                  })
                  .join("") +
                "</ul>";
            }

            // Mensaje principal, todo alineado a la izquierda
            let mensajeResumen =
              `<div style="text-align: left;">` +
              `<p>✅ <strong>${data.productosActualizados || 0}</strong> ${vm.$t('productosActualizadosResumen')}<br>` +
              `🔍 <strong>${data.productosNoEncontrados || 0}</strong> ${vm.$t('productosNoEncontradosResumen')}<br>` +
              `ℹ️ <strong>${data.productosSinCambios || 0}</strong> ${vm.$t('productosSinCambiosResumen')}</p>` +
              (duplicados.length > 0
                ? `<p><strong>${vm.$t("advertenciaPLUsDuplicadosProductos")}</strong></p>${mensajeDuplicados}`
                : "") +
              `</div>`;

            // Mostrar swal SIEMPRE con el resumen
            swal({
              title: data.success
                ? vm.$t("pluReplicadosExitosamente")
                : vm.$t("atencion"),
              html: mensajeResumen,
              confirmButtonClass: "btn btn-info btn-fill",
              type: data.success ? "success" : "error",
            });
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.log("Error:", error);
            let errorMessage = vm.$t("errorDesconocido");
            if (error.response) {
              errorMessage = error.response.data.message || errorMessage;
            }
            swal({
              title: vm.$t("atencion"),
              text: errorMessage,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    replicarPLUSubProductosBusiness() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness, // origen
          idsBusinesses: this.selectedBusinessCompanySubproducts, // destinos
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
            "integracion/gstock/replicarSubProductsPLUBusiness",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            // Datos de respuesta
            let data = response.data;

            // Construir resumen de nombres duplicados si existen
            let duplicados =
              data.subproductosConNombresDuplicadosEnOrigen || [];

            let mensajeDuplicados = "";
            if (duplicados.length > 0) {
              mensajeDuplicados =
                "<ul style='padding-left: 20px;'>" +
                duplicados
                  .map(function (d) {
                    return `<li><strong>${d.name}</strong> ${vm.$t('seRepite')} ${d.ids.length} veces.</li>`;
                  })
                  .join("") +
                "</ul>";
            }

            // Mensaje principal
            let mensajeResumen =
              `<div style="text-align: left;">` +
              `<p>✅ <strong>${data.subproductosActualizados || 0}</strong> ${vm.$t('subproductosActualizadosResumen')}<br>` +
              `🔍 <strong>${data.subproductosNoEncontrados || 0}</strong> ${vm.$t('subproductosNoEncontradosResumen')}<br>` +
              `ℹ️ <strong>${data.subproductosSinCambios || 0}</strong> ${vm.$t('subproductosSinCambiosResumen')}<br>` +
              (duplicados.length > 0
                ? `<p><strong>${vm.$t("advertenciaPLUsDuplicadosSubproductos")}</strong></p>${mensajeDuplicados}`
                : "") +
              `</div>`;

            // Mostrar swal SIEMPRE con el resumen
            swal({
              title: data.success
                ? vm.$t("pluReplicadosExitosamente")
                : vm.$t("atencion"),
              html: mensajeResumen,
              confirmButtonClass: "btn btn-info btn-fill",
              type: data.success ? "success" : "error",
            });
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.log("Error:", error);
            let errorMessage = vm.$t("errorDesconocido");
            if (error.response) {
              errorMessage = error.response.data.message || errorMessage;
            }
            swal({
              title: vm.$t("atencion"),
              text: errorMessage,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    toggleSelectAllProducts(checked) {
      if (checked) {
        this.selectedBusinessCompany = this.listBusinessesCompany.map(b => b.id);
      } else {
        this.selectedBusinessCompany = [];
      }
    },


    confirmarReplicacionProductos() {
      swal({
        title: '¿Está seguro?',
        text: 'Con esta acción replicará los PLU en los TPVs relacionados a este negocio.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarProductosTpvs();
        }
      });
    },

    confirmarReplicacionProductosPLUBusiness() {
      swal.fire({
        title: this.$t("estasSeguro"),
        html: `
          <p>${this.$t("conEstaAcciónPLU")}</p>
          <p style="margin-top: 10px; text-align: left;">
            ⚠️ <strong>${this.$t("advertenciaPLUTexto1Prod")}</strong><br>
            ${this.$t("advertenciaPLUTexto2Prod")}
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarPLUsProductosBusiness();
          this.closeModal();
        }
      });
    },

    closeModal() {
      this.$modal.hide("modalSeleccionBusiness");
    },

    confirmarReplicacionSubproductos() {
      swal.fire({
        title: '¿Está seguro?',
        text: 'Con esta acción replicará los PLU en los TPVs relacionados a este negocio.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarMateriasPrimasTpvs();
        }
      });
    },

    confirmarReplicacionSubProductosPLUBusiness() {
      swal.fire({
        title: '¿Está seguro?',
        text: 'Con esta acción replicará los PLU en todos los TPVs de los negocios seleccionados.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarPLUSubProductosBusiness();
          this.closeModalSubproducts();
        }
      });
    },

    confirmarReplicacionSubproductos() {
      swal.fire({
        title: '¿Está seguro?',
        text: 'Con esta acción replicará los PLU en los TPVs relacionados a este negocio.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarMateriasPrimasTpvs();
        }
      });
    },

    confirmarReplicacionSubProductosPLUBusiness() {
      swal.fire({
        title: this.$t("estasSeguro"),
        html: `
          <p>${this.$t("conEstaAcciónPLUSubProductos")}</p>
          <p style="margin-top: 10px; text-align: left;">
            ⚠️ <strong>${this.$t("advertenciaSubPLUTexto1")}</strong><br>
            ${this.$t("advertenciaSubPLUTexto2")}
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarPLUSubProductosBusiness();
          this.closeModalSubproducts();
        }
      });
    },

    toggleSelectAllSubproducts(checked) {
      if (checked) {
        this.selectedBusinessCompanySubproducts = this.listBusinessesCompany.map(b => b.id);
      } else {
        this.selectedBusinessCompanySubproducts = [];
      }
    },

    checkIfAllSelectedProducts() {
      this.selectAllProducts = this.selectedBusinessCompany.length === this.listBusinessesCompany.length;
    },

    checkIfAllSelected() {
      this.selectAll = this.selectedBusinessCompanySubproducts.length === this.listBusinessesCompany.length;
    },

    closeModalSubproducts() {
      this.$modal.hide("modalSeleccionBusinessSubproducts");
    },

    confirmarReplicacionSubproductos() {
      swal.fire({
        title: this.$t("estasSeguro"),
        text: this.$t("conEstaAccionPLUTpvs"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarMateriasPrimasTpvs();
        }
      });
    },

    confirmarReplicacionProductos() {
      swal({
        title: this.$t("estasSeguro"),
        text: this.$t("conEstaAccionPLUTpvs"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarProductosTpvs();
        }
      });
    },

    getBusinessesByCompanyId(idBusiness) {

      var config = {
          params: {
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      var params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
      };

      return this.axios
        .post(
          this.$store.getters.apiUrl + "businesses/IdsAndNamesByCompanyId",
          params,
          config
        )
        .then(res => {
          const businesses = Array.isArray(res.data) ? res.data : res.data.result || [];
          this.listBusinessesCompany = businesses.map(item => ({
            id: item.id,
            establishmentName: item.establishmentName || item.name || 'Sin nombre',
          }));
          this.$emit('businessesCompanyUpdated', this.listBusinessesCompany);
        })
        .catch(err => {
          let message = 'Error desconocido';
          if (err.response && err.response.data && err.response.data.error) {
            message = err.response.data.error;
          } else if (err.message) {
            message = err.message;
          }

          console.error("Error al obtener negocios por companyId:", message);
          this.listBusinessesCompany = [];
          this.$emit('businessesCompanyUpdated', this.listBusinessesCompany);
        });
    },


  },


};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

body {
  background: #1d1f20;
  padding: 16px;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}

.btn-info {
  background-color: #1e22aa;
}

.btn {
  padding: 10px 16px !important;
  border-radius: 4px !important;
  font-weight: bold !important;
  transition: background-color 0.3s ease, color 0.3s ease !important;
}

.btn-primary {
  background-color: #007bff !important;
  color: white !important;
  border: 1px solid #007bff !important;
}

.btn-primary:hover {
  background-color: #0069d9 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/ProductosNoRelacionados/ProductosNoRelacionados.vue